var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-video-frame"},[_c('video',{ref:"video",staticClass:"video"},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }